module.exports = __webpack_public_path__ + "static/ELEVATE Atlanta Art Festival - word logo-f0cb6da9b514567bed2ad34fbb6360d8.png";